// Screen 8 — Restrictions (wizard step 7 of 9). Optional; skip allowed.
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WizardScreen } from '../../components/planner/WizardScreen';
import { CheckboxList } from '../../components/planner/CheckboxList';
import { FieldError } from '../../components/planner/FieldError';
import { useDraft, STEP_ROUTES } from '../../lib/plannerDraft';

const RESTRICTIONS = [
  { id: 'no_beef', label: 'No beef' },
  { id: 'no_pork', label: 'No pork' },
  { id: 'no_dairy', label: 'No dairy' },
  { id: 'no_spicy', label: 'No spicy' },
  { id: 'other', label: 'Other' },
];

export default function Step8Restrictions() {
  const nav = useNavigate();
  const { draft, patch, bump } = useDraft();
  const [showErr, setShowErr] = useState(false);

  const showOther = draft.restrictions.includes('other');
  const needsOtherText =
    showOther && !draft.restrictions_other_description.trim();

  const valid = !needsOtherText;

  const advance = () => {
    if (!valid) { setShowErr(true); return; }
    bump(8);
    nav(STEP_ROUTES[8]);
  };

  return (
    <WizardScreen
      step={7}
      eyebrow="Restrictions"
      title="Any restrictions?"
      canContinue={valid}
      onContinue={advance}
      extraFooter={
        draft.restrictions.length === 0 && (
          <button
            type="button"
            onClick={() => { patch({ restrictions: [] }, { invalidateGeneration: true }); advance(); }}
            className="text-sm underline underline-offset-4"
            style={{ color: 'var(--ink)' }}
            data-testid="restrictions-skip-btn"
          >
            I have none
          </button>
        )
      }
    >
      <p className="text-sm mb-5" style={{ color: 'var(--text-dim)' }}>
        Meals matching these will be filtered out. You can skip this step.
      </p>

      <CheckboxList
        options={RESTRICTIONS}
        value={draft.restrictions}
        onChange={(v) => patch({ restrictions: v }, { invalidateGeneration: true })}
        ariaLabel="Restrictions"
        testIdPrefix="restriction"
      />

      {showOther && (
        <label className="block mt-4">
          <span className="font-display uppercase tracking-wider text-sm">
            Please describe (short)
          </span>
          <input
            type="text"
            maxLength={120}
            value={draft.restrictions_other_description}
            onChange={(e) => patch({ restrictions_other_description: e.target.value }, { invalidateGeneration: true })}
            data-testid="restriction-other-desc-input"
            className="mt-2 w-full"
            style={{
              padding: '12px 14px',
              border: '1.5px solid var(--line)',
              borderRadius: 'var(--radius)',
              background: '#fff',
              fontSize: '16px',
            }}
          />
        </label>
      )}

      <FieldError id="restriction-error">
        {showErr && needsOtherText
          ? 'Please add a short description for "Other".'
          : null}
      </FieldError>
    </WizardScreen>
  );
}
